import styled from 'styled-components';

export const ButtonLayout = styled.div`
  display: grid;
  grid-column-gap: 8px;
  grid-template-columns: 1fr 1fr;
  padding-top: 24px;
`;
